<div class="row">
    @if (allowRequestStatusChange)
    {
    <div style="width: calc(50% - 25px);position: relative;left: 10px;">
        <div style="width: 100%;float: right;display: flex;position: relative;left: 25px;">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic" matTooltip="request status">
                <mat-label>request status</mat-label>
                <mat-select [disabled]="isLoading" [value]="requestStatus"
                    (selectionChange)="onChangeRequestStatus($event)">
                    @for (option of workflowRequestStateKeys; track option.value) {
                    <mat-option [value]="option.value">{{option.displayName}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div style="width: calc(50% - 25px);padding-left: 25px;position: relative;left: 25px;">
        <div style="width: 100%;float: right;display: flex;">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic" matTooltip="request type">
                <mat-label>last number of months to display</mat-label>
                <mat-select [disabled]="isLoading" [value]="numberOfMonths"
                    (selectionChange)="onChangeMonthsBack($event)">
                    @for (option of numberOfMonthsOptions; track option.value) {
                    <mat-option [value]="option.value">{{option.displayName}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    }
    <div style="position: relative;width: 100%;height:100%;aspect-ratio: 2;" class="col col-12">
        <canvas [hidden]="isLoading" style="width: 100%; height: 100%;aspect-ratio: 2;" [id]="chartId"
            class="chart chart-bar">
            {{ chart }}
        </canvas>
        <div class="d-flex justify-content-center align-items-center h-100">
            <mat-spinner [hidden]="!isLoading"></mat-spinner>
        </div>
    </div>


</div>
@if(showDetails && !isLoading)
{
<div class="row">
    <div class="col col-12">
        <h3>request details</h3>
        <app-workflow-request-display [requests]="requestResults" [includeFilter]="true" [includePaginator]="true"
            [showRequestorPicker]="false"></app-workflow-request-display>
    </div>
</div>
}